import { render, staticRenderFns } from "./TairHome.vue?vue&type=template&id=8e3e561c&scoped=true"
import script from "./TairHome.vue?vue&type=script&lang=js"
export * from "./TairHome.vue?vue&type=script&lang=js"
import style0 from "./TairHome.vue?vue&type=style&index=0&id=8e3e561c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3e561c",
  null
  
)

export default component.exports